export enum DARWIN_EXPERIMENT_NAMES {
  MOBILE_WEB_PDP_EXPERIMENT = 'new_mobile_web_pdp_2024',
  WEB_OFFERS_LOGIN_TEST = 'web_offers_login_test_2024',
  WEB_WANTS_PDP_PURCHASE_FLOW = 'web_wants_pdp_purchase_flow',
}
